'use client';

import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';

const CleanUrlParams = () => {
  const router = useRouter();
  const hasCleanedRef = useRef(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    // Only run once per component mount and avoid interference with navigation
    if (hasCleanedRef.current) return;
    hasCleanedRef.current = true;

    const url = new URL(window.location.href);
    const originalUrl = url.toString();

    // Remove 'path' query parameter(s)
    url.searchParams.delete('path');

    // Optional: Remove other unwanted params
    // url.searchParams.delete('anotherParam');

    const cleanedUrl = url.toString();

    // Only update if the URL actually changed, and use router.replace instead of history.replaceState
    if (originalUrl !== cleanedUrl) {
      // Use Next.js router to maintain proper navigation state
      const newPath = url.pathname + url.search + url.hash;
      router.replace(newPath, undefined, { shallow: true });
    }
  }, [router]);

  return null;
};

export default CleanUrlParams;
